
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/libraries",
      function () {
        return require("private-next-pages/docs/api/libraries.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/libraries"])
      });
    }
  